import axios from "@/axios";
import { RoutesEnum } from "@/enums";
import { buildFullUrl } from "@/lib/url";

const Verification = {
  sendRepresentativeDashboardEmail: async (email, name) => {
    const representativeUrl = buildFullUrl(RoutesEnum.REPRESENTATIVE);
    return axios.post(RoutesEnum.SEND_REPRESENTATIVE_EMAIL, {
      to: email,
      firstName: name,
      baseUrl: `${representativeUrl}`,
      subject: "Welcome to BetaScore AI",
    });
  },
};

export default Verification;
